
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App.tsx';
import './index.css';
import { PERMISSIONS_STORAGE_KEY } from './hooks/rollenbeheer/defaultPermissions.ts';
import { setupVersionChecker } from './utils/cacheControl.ts';

// Clear localStorage on development to avoid stale permission data
if (import.meta.env.DEV) {
  // Always reset permissions in development to ensure a clean state
  console.log("Development mode: Clearing permissions data for fresh state");
  localStorage.removeItem(PERMISSIONS_STORAGE_KEY);
  
  // Log environment variables to help with debugging
  console.log("Environment variables:", {
    SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL ? "✓ defined" : "✗ missing",
    SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY ? "✓ defined" : "✗ missing"
  });
}

// Start versiecontrole (alleen in productie)
if (!import.meta.env.DEV) {
  setupVersionChecker();
  console.log(`App versie: ${new Date().toISOString()}`);
}

// Make sure to render in StrictMode for consistency
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
